// TEXT input for "ProductCategory"
const Input = {
    // General Information
    name: {
      category:'Clothing',
    },
  
    // Sort Filter
    sortOptions: [
        { name: 'Most Popular', href: 'https://www.google.com/', current: true },
        { name: 'Best Rating', href: 'https://www.google.com/', current: false },
        { name: 'Newest', href: 'https://www.google.com/', current: false },
        { name: 'Price: Low to High', href: 'https://www.google.com/', current: false },
        { name: 'Price: High to Low', href: 'https://www.google.com/', current: false },
    ],
  
    // Category Filter
    subCategories: [
        { name: 'Tops', href:'/luna-demo/men/clothing/tops'},
        { name: 'Bottoms', href: '/luna-demo/men/clothing/bottoms' },
        { name: 'Innerwear', href: '/luna-demo/men/clothing/innerwear' },
        { name: 'Outerwear', href: '/luna-demo/men/clothing/outerwear' },
        { name: 'Activewear', href: '/luna-demo/men/clothing/activewear' },
    ],
  
    // Specific Category Filters
    filters: [
      {
        id: 'category',
        name: 'Category',
        options: [
          { value: 'new-arrivals', label: 'New Arrivals', checked: false },
          { value: 'sale', label: 'Sale', checked: false },
          { value: 'travel', label: 'Travel', checked: false },
          { value: 'organization', label: 'Organization', checked: false },
          { value: 'accessories', label: 'Accessories', checked: false },
        ],
      },    
      {
        id: 'color',
        name: 'Color',
        options: [
          { value: 'white', label: 'White', checked: false },
          { value: 'beige', label: 'Beige', checked: false },
          { value: 'blue', label: 'Blue', checked: false },
          { value: 'brown', label: 'Brown', checked: false },
          { value: 'green', label: 'Green', checked: false },
          { value: 'purple', label: 'Purple', checked: false },
        ],
      },
      {
        id: 'size',
        name: 'Size',
        options: [
          { value: '2l', label: '2L', checked: false },
          { value: '6l', label: '6L', checked: false },
          { value: '12l', label: '12L', checked: false },
          { value: '18l', label: '18L', checked: false },
          { value: '20l', label: '20L', checked: false },
          { value: '40l', label: '40L', checked: false },
        ],
      },
    ],
  
    // Product Listing
    products: [
      {
        id: 1,
        name: 'Cotton Tee',
        category: "Ladies Tops",
        href: './tops/nike1',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p6.png',
        imageAlt: 'image 1',
      },
      {
        id: 2,
        name: 'Cotton Skirt',
        category: "Skirts",
        href: './bottoms/zara1',
        price: '$30',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p9.png',
        imageAlt: 'image 2',
      },
      {
        id: 3,
        name: 'Loose Pants',
        category: "Pants",
        href: './bottoms/zara2',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p3.png',
        imageAlt: 'image 3',
      },
      {
        id: 4,
        name: 'Summer Collar Shirt',
        category: "Ladies Tops",
        href: './tops/nike4',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p1.png',
        imageAlt: 'image 4',
      },
      {
        id: 5,
        name: 'Summer Dress',
        category: "Dresses",
        href: './tops/nike2',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p6.png',
        imageAlt: 'image 5',
      },
      {
        id: 6,
        name: 'Summer Skirt',
        category: "Skirts",
        href: './bottoms/zara3',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p4.png',
        imageAlt: 'image 6',
      },
      {
        id: 7,
        name: 'Cotton Tank Top',
        category: "Ladies Tops",
        href: './tops/nike3',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p9.png',
        imageAlt: 'image 7',
      },
      {
        id: 8,
        name: 'Jeans Shorts',
        category: "Ladies Pants",
        href: './bottoms/zara4',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p2.png',
        imageAlt: 'image 8',
      },
      {
        id: 9,
        name: 'Loose Jacket',
        category: "Ladies Tops",
        href: './tops/nike5',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p7.png',
        imageAlt: 'image 8',
      },
    ]
  }
  
  export default Input;